import React, { useEffect, useMemo, useState } from "react"
import MirsTable from "components/general/table/Table"
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import Label from "components/general/Label";
import Noc from "components/presentation/Noc";
import { isParalympic, CompetitionFromStore } from 'helpers/utils'
import Competitor from 'components/presentation/Competitor';
import Discipline from 'components/presentation/Discipline';
import useViewport from "components/general/useViewPort";

const getConfiguration = ({ breakPoint, isAlphabeticalSort = true, params }) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false
  };
  configuration.sortBy = [{ id: 'Discipline', desc: false }, { id: 'NOC', desc: false }, { id: 'Event', desc: false }, { id: 'Competitor', desc: false }];
  configuration.columns = TableColumns({ isAlphabeticalSort, params })
  configuration.columns = isMobile ? TableColumnsSM({ isAlphabeticalSort, params }) : TableColumns({ isAlphabeticalSort, params });
  return configuration;
};


const TeamsTable = ({ data }) => {
  const { breakPoint } = useViewport();

  const [isAlphabeticalSort, setIsAlphabeticalSort] = useState(true);
  const params = useUrlFriendlyToParameters();
  const config = useMemo(() => getConfiguration({ breakPoint, isAlphabeticalSort, params }), [breakPoint, isAlphabeticalSort, params]);
  useEffect(() => {
    let isAlphabetical = !(data?.some(team => team?.discipline?.descriptionOrder && team?.discipline?.descriptionOrder !== 0));
    setIsAlphabeticalSort(isAlphabetical);
  }, [data]);

  return (

    <MirsTable
      className="table-schedule"
      data={data}
      columns={config.columns}
      keyRow='eventUnit-code'
      initialSortBy={config.sortBy}
      id={`mirs-table-teams`}
      showPagination={true}
    // pageSizeCustom={10}
    />


  )
}

export default TeamsTable;



function TableColumns({ isAlphabeticalSort = true, params }) {
  return (
    [
      ColumnCompetitor(),
      ColumnNoc({ params, longDesc: true }),
      ColumnDiscipline({ isAlphabeticalSort }),
      ColumnEvent()
    ]
  )
}

function TableColumnsSM({ isAlphabeticalSort = true, params }) {
  return (
    [
      ColumnCompetitor(),
      ColumnNoc({ params, longDesc: false }),
      ColumnDiscipline({ isAlphabeticalSort }),
      ColumnEvent()
    ]
  )
}


export function ColumnDiscipline({ isAlphabeticalSort = true }) {
  return (
    {
      Header: <Label data="HeaderDiscipline" />,
      className: 'schedule-discipline text-start',
      sortType: isAlphabeticalSort ? 'absoluteOrderString' : 'absoluteOrderNumber',
      accessor: (props) => {
        return isAlphabeticalSort ? props?.discipline?.description?.toLowerCase() : props?.discipline?.descriptionOrder;
      },
      headerClassName: 'text-start w-25',
      disableSortBy: false,
      id: 'Discipline',
      multiSort: [{ id: 'Discipline' }, { id: 'NOC', desc: false }, { id: 'Event', desc: false }, { id: 'Competitor', desc: false }],
      Cell: (props) => {
        const discipline = props.cell.row.original?.discipline
        return (
          <Discipline hasLink={true} code={discipline?.code} description={discipline?.description} />

        )
      }
    }
  )
}

export function ColumnNoc({ params = {}, longDesc = true }) {
  const competition = CompetitionFromStore();

  return (
    {
      Header: <Label data={isParalympic(competition) ? 'HeaderNPC' : 'HeaderNOC'} />,
      id: 'NOC',
      className: 'text-start',
      headerClassName: 'text-start w-25',
      accessor: (props) => props?.organisation?.longDescriptionOrder,
      disableSortBy: false,
      multiSort: [{ id: 'NOC' }, { id: 'Discipline', desc: false }, { id: 'Event', desc: false }, { id: 'Competitor', desc: false }],
      Cell: (props) => {
        let data = props.cell.row.original?.organisation;
        return (<Noc {...data} showImage={true} showLongDesc={longDesc} hasLink={true} showImgAlt={false} />);
      }
    }
  )

}

export function ColumnCompetitor() {
  return (
    {
      Header: <Label data="LabelName" />,
      id: 'Competitor',
      className: 'schedule-discipline text-start',
      headerClassName: 'text-start w-25',
      accessor: (props) => props?.name?.toLowerCase(),
      disableSortBy: true,
      Cell: (props) => {
        const row = props.cell.row.original
        return (<Competitor noLink={false} {...row} hideNoc={true} hidePicture={true} key={`participant-${row?.code}`} />);
      }
    }
  )
}

export function ColumnEvent() {
  return (
    {
      Header: <Label data="LabelEvent" />,
      id: 'Event',
      className: 'schedule-discipline text-start',
      headerClassName: 'text-start',
      disableSortBy: true,
      accessor: (props) => props?.registeredEvents?.at(0)?.event?.order,
      Cell: (props) => {
        const row = props.cell.row.original
        return (
          <>
            {row?.registeredEvents?.map((e) => {
              return (
                <div key={e?.code}>{e?.event?.longDescription}</div>
              )
            })}
          </>
        )
      }
    }
  )
}
